import { useTranslation } from "react-i18next";
import React, {useEffect, useReducer} from "react";
import Error404 from "../../../../../Error404";
import {mainParticipationDataAPI, mainParticipationSAVEDataAPI} from "../../../../../../services/api/project";
import "bootstrap/dist/css/bootstrap.min.css";
import DarkCard from "../../../../../../components/card/DarkCard";
import { Link } from "react-router-dom";
import ParticipationTableGenerator from "./ParticipationTableGenerator";
import ParticipationDetailForm from "./ParticipationDetailForm";
import {INITIAL_REDUCER_STATE, participationReducer} from "./projectReducers/MainParticipationReducer";

function getStatusForInstrumentProjectUser(data, instrumentName, projectId, user_id) {
    const instrumentUsers = data.find(([instrument]) => instrument === instrumentName);
    if (!instrumentUsers) {
        return "";
    }
    const users = instrumentUsers[1]; // Lista użytkowników grających na instrumencie

    // const filteredUser = users
    //     .map(user => {
    //         if (user.username === username) {
    //             const participation = user.participation[projectId]
    //             return participation ? { username: user.username, status: participation.status } : null
    //         }
    //         return null
    //     })
    //     .filter(user => user !== null)
    // Filtrujemy użytkowników po nazwie, projekcie i statusie
    const user = users.find(user => user.user_id === user_id && user.participation[projectId])
    if (user) {
        return user.participation[projectId].status
    }
    return "";
}


const MainParticipationView = () => {
    const { t } = useTranslation();
    const [state, dispatch] = useReducer(participationReducer, INITIAL_REDUCER_STATE, undefined)

    useEffect(() => {
        const get_DataAPI = async () => {
            const response = await mainParticipationDataAPI();
            if (response.status === 200) {
                dispatch({
                    type: 'INITIAL_DATA',
                    projects: response.data.projects_list,
                    users: response.data.users,
                })
            } else {
                return <Error404 />;
            }
        };

        if (state.showTable) {
            get_DataAPI()
        };

    }, [state.showTable]);

    const handleCopyEmail = (email) => {
        if (email) {
            navigator.clipboard.writeText(email);
            dispatch({
                type: "SET_COPY_SUCCESS",
                copySuccess: t("project.availabilities.mail_copy_message", { email: email})
            })
            // Close alert after 5 seconds
            setTimeout(() => {
                dispatch({ type: "SET_COPY_SUCCESS", copySuccess: null });
            }, 5000);
        }
    };

    const ChangeDBHandler = (val, projectID, userID, instrument, confirm, is_filled_form) => {
        // wpis do inputa = zapis do bazy i odświeżenie strony // zmien inne pozycje muzyka (inny instrument) na "--"
        const instr_proj_user_status = getStatusForInstrumentProjectUser(state.users, instrument, projectID, userID);

        if (val === instr_proj_user_status) {
            return
        }

        const newData = {
            projectID: projectID,
            userID: userID,
            status: val,
            instrument: instrument,
            confirm: confirm,
        }

        const saveData =async () => {
            const response = await mainParticipationSAVEDataAPI(newData)
            if (response.status !== 200) {
                console.log("ERROR>>>>>>: ", response)
            }
        }
        saveData();

        dispatch({
            type: "SET_INPUT_VALUE",
            payload: {
                instrumentName: instrument,
                userId: userID,
                projectId: projectID,
                newValue: val,
                is_filled_form: is_filled_form,
            },
        })
    }

    return (
        <>
            {state.copySuccess && (
                <div className="alert alert-success fade show mt-3" role="alert"
                style={{
                    position: "fixed",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1050,
                }}>
                    {state.copySuccess}
                </div>
            )}
    
            <DarkCard classNames="mb-3 row">
                <p className="m-0 p-0 breadcrumbs">
                    <span className="txt">{t("menu.projects", { ns: "menu" })}</span>&#8201;&#9656;&#8201;
                    <Link to={"/projects/main-participation-view"}>{t("menu.main_participation_view", { ns: "menu" })}</Link>
                </p>
            </DarkCard>
            {state.showTable ?
                <DarkCard classNames="mb-3 row">
                    <h1 className="mb-0 mt-0 p-0" style={{ marginTop: "-5px" }}>
                        {t("project.availabilities.page_title")}
                    </h1>
                    <div className="table-responsive">
                        <ParticipationTableGenerator
                            t={t}
                            users={state.users}
                            projects={state.projects}
                            dispatch={dispatch}
                            ChangeDBHandler={ChangeDBHandler}
                            handleCopyEmail={handleCopyEmail}
                        />
                    </div>
                </DarkCard>
                :
                <ParticipationDetailForm
                    detailFormProps={state.detailFormProps}
                    dispatch={dispatch}
                />
            }
        </>
    );
};

export default MainParticipationView;